import { render, staticRenderFns } from "./SubheadingInput.vue?vue&type=template&id=d4bc4d40&scoped=true&"
import script from "./SubheadingInput.vue?vue&type=script&lang=js&"
export * from "./SubheadingInput.vue?vue&type=script&lang=js&"
import style0 from "./SubheadingInput.vue?vue&type=style&index=0&id=d4bc4d40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bc4d40",
  null
  
)

export default component.exports